const CURRENCY_ALIASES = {
  AR: 'ARS',
}

export function normalizeCurrencyCode(value, fallback = 'USD') {
  const raw = String(value || '').trim().toUpperCase()
  const normalized = CURRENCY_ALIASES[raw] || raw
  if (normalized) return normalized
  if (fallback === '') return ''
  return normalizeCurrencyCode(fallback, '')
}

export function formatCurrencyAmount(value, currency, options = {}) {
  const { showSymbol = true } = options
  const amount = Number.parseFloat(value)
  const normalizedCurrency = normalizeCurrencyCode(currency)
  const formattedAmount = Number.isFinite(amount)
    ? new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)
    : '0.00'

  const symbol = normalizedCurrency === 'EUR' ? '€' : '$'
  return `${showSymbol ? symbol : ''}${formattedAmount} ${normalizedCurrency}`
}
